export default "__VITE_ASSET__CN0sW17o__"